<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content *ngIf="composition">
  <mat-card appearance="outlined" class="composition-info">
    <p>
      <mat-form-field>
        <input [(ngModel)]="composition.title" matInput placeholder="Title">
      </mat-form-field>
    </p>
    <p *ngIf="isCopy && organisations">
      <mat-select (selectionChange)="setOrganisation($event)" placeholder="Select Organisation">
        <mat-option *ngFor="let org of organisations" [value]="org.OrganisationID">{{org.title}}</mat-option>
      </mat-select>
    </p>
    <p *ngIf="isCopy && orgCustomers">
      <mat-select (selectionChange)="setCustomer($event)" placeholder="Select Customer">
        <mat-option *ngFor="let customer of orgCustomers" [value]="customer._id">{{customer.organisationName}}</mat-option>
      </mat-select>
    </p>
  </mat-card>
  <mat-card appearance="outlined">
    <mat-tab-group>
      <mat-tab label="1. Screen">
        <app-composition-wizard-screen [composition]="composition"></app-composition-wizard-screen>
      </mat-tab>
      <mat-tab label="2. Meta">
        <app-composition-wizard-meta [composition]="composition"></app-composition-wizard-meta>
      </mat-tab>
      <mat-tab label="3. Imports">
        <app-composition-wizard-imports [composition]="composition"></app-composition-wizard-imports>
      </mat-tab>
      <mat-tab label="4. Dynamic Content Entrances">
        <app-composition-wizard-dynamic-entrance (save)="saveComposition()"
                                                 [composition]="composition"></app-composition-wizard-dynamic-entrance>
      </mat-tab>
      <mat-tab label="5. Snippets">
        <app-composition-wizard-code-snippets [composition]="composition"></app-composition-wizard-code-snippets>
      </mat-tab>
      <mat-tab label="6. Summary">
        <app-composition-wizard-summary [composition]="composition"></app-composition-wizard-summary>
        <button (click)="saveComposition()" color="primary" mat-raised-button>Save</button>
      </mat-tab>
    </mat-tab-group>
  </mat-card>
</page-content>
